import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const data = [
  {
    sl: 1,
    refNo: '420125080000002',
    policyNo: '4101025080000001-00',
    batchNo: '2025080114085149918157142',
    corporate: 'DML Group of companies',
    fileName: '420125080000002.xlsx',
    status: 'Validation completed',
    uploadedBy: 'Mr Harshad patil',
    uploadTime: '01 Aug, 2025 02:08 PM',
    downloadLink: '#',
  },
];

const UnderwritingsApproval = () => {
  const [filterType, setFilterType] = useState('');
  const [uploadDate, setUploadDate] = useState('');
  const [policyCode, setPolicyCode] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = event => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleUpload = () => {
    if (!selectedFile) return alert('Please choose a file first.');
    // Add your file upload logic here
    alert(`Uploading: ${selectedFile.name}`);
  };

  const handleDownload = () => {
    // Replace with actual format file URL
    const link = document.createElement('a');
    link.href = '/path/to/sample_format.xlsx';
    link.download = 'sample_format.xlsx';
    link.click();
  };

  return (
    <Box>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Underwriting Approval List
      </Box>
      <Box
        style={{
          display: 'flex',
          //   justifyContent: 'end',
          alignItems: 'flex-end',
          marginTop: '1rem',
          flexDirection: 'column',
        }}>
        <Box display="flex" alignItems="flex-end" gap="2rem" style={{ display: 'flex', gap: '1rem' }}>
          {/* Filter Type Dropdown */}
          <Box sx={{ width: 220 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="filter-type-label">Search By</InputLabel>
              <Select
                labelId="filter-type-label"
                label="Filter By"
                value={filterType}
                onChange={e => setFilterType(e.target.value)}>
                <MenuItem value="">Select...</MenuItem>
                <MenuItem value="policy">Policy Code</MenuItem>
                <MenuItem value="date">Upload Date</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Conditional Inputs */}
          {filterType === 'policy' && (
            <Box>
              <TextField
                label="Policy Code"
                size="small"
                value={policyCode}
                onChange={e => setPolicyCode(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}

          {filterType === 'date' && (
            <>
              <Box sx={{ minWidth: 160 }}>
                <TextField
                  label="Upload Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={uploadDate}
                  onChange={e => setUploadDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </>
          )}

          {/* Search Button with extra margin on Date Range */}
          <Box style={{ display: 'flex', gap: '1rem' }}>
            <Button variant="contained" color="primary">
              Search
            </Button>
          </Box>
        </Box>
        <Box style={{ marginTop: '1rem', marginRight: '5.7rem' }} sx={{ width: 220 }}>
          <TextField
            type="file"
            variant="outlined"
            size="small"
            InputProps={{
              sx: {
                height: '50px', // Adjust height as needed
              },
            }}
            inputProps={{
              style: {
                padding: '11px', // Optional: adjust padding inside the input
              },
            }}
            onChange={handleFileChange}
          />
        </Box>
      </Box>
      <Box style={{ marginTop: '2rem' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 1200, borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#00A0E3', color: 'white' }}>
                {[
                  'SL#',
                  'Ref No',
                  'Policy No',
                  'Batch No',
                  'Corporate',
                  'File Name',
                  'Status',
                  'Uploaded By',
                  'Upload Time',
                  'Download',
                  'Upload',
                ].map((heading, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      color: 'white',
                      fontWeight: 'bold',
                      border: '1px solid white',
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                    }}>
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{row.sl}</TableCell>
                  <TableCell align="center">{row.refNo}</TableCell>
                  <TableCell align="center">{row.policyNo}</TableCell>
                  <TableCell align="center">{row.batchNo}</TableCell>
                  <TableCell align="center">{row.corporate}</TableCell>
                  <TableCell align="center">{row.fileName}</TableCell>
                  <TableCell align="center">{row.status}</TableCell>
                  <TableCell align="center">{row.uploadedBy}</TableCell>
                  <TableCell align="center">{row.uploadTime}</TableCell>
                  <TableCell align="center">
                    <Link href={row.downloadLink} underline="hover" onClick={handleDownload}>
                      Download File
                    </Link>
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="outlined" size="small" onClick={handleUpload}>
                      Upload
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default UnderwritingsApproval;
